module.exports = __webpack_public_path__ + "static/media/shaa.ee108ed4.png";